import { axiosPublic } from './common/axiosPublic';
import { axiosPrivate } from './common/axiosPrivate';
import { getQueryParams, handleResponse, handleError } from '../../helpers/network';

export const list = async ({ filter = '', page = 1, size = 10 }) => {
    const params = getQueryParams({ filter, page, size });
    return axiosPublic.get(`/categories?${params}`).then(handleResponse).catch(handleError);
};

export const get = async (id) => {
    return axiosPublic.get(`/categories/${id}`).then(handleResponse).catch(handleError);
};

export const create = async (item) => {
    return axiosPrivate.post(`/categories`, item).then(handleResponse).catch(handleError);
};

export const update = async (item) => {
    return axiosPrivate.put(`/categories/${item.id}`, item).then(handleResponse).catch(handleError);
};

export const remove = async (id) => {
    return axiosPrivate.delete(`/categories/${id}`).then(handleResponse).catch(handleError);
};
